import axios from "axios";

const base = "https://api.industrialautomationsupply.com";

const client = axios.create({
  baseURL: base,
  headers: { "Content-Type": "application/json" },
  timeout: 10000,
});

export async function fetchJson(path, options = {}) {
  const {
    method = "get",
    data = undefined,
    params = undefined,
    headers = {},
  } = options;
  try {
    const res = await client.request({
      url: path,
      method,
      data,
      params,
      headers,
    });
    return res.data;
  } catch (err) {
    if (err.response) {
      const payload = err.response.data;
      const message =
        (payload && (payload.message || payload.error)) ||
        err.response.statusText;
      throw new Error(message);
    }
    throw err;
  }
}

export default fetchJson;
